import { MSG_ERRO_FORMULÁRIO_INCOMPLETO } from '../../shared/constantes/mensagens';
const MSG_SIMULACAO_ERRO_SOLICITAR = "Não é possível gerar a simulação.";

const INITIAL_STATE = {
    data: {
        extrato: { listaVinculosTO:null, listaAtividadesTO:[], listaMicroFichasTO:[], listaIndicadoresTO:[] },
        consultaFiliado: { filiadoTO: {dataNascimento: '', sexo: "MASCULINO"}, listaEloTO: [] }
    },
    edicao: { cardId: null, remuneracoes:[], dataInicio:"", dataFim:"", nomeVinculo:"" },

    loadingExtrato: false,
    loading: false,
    erroElegivel: false,
    semExtrato: false,
    resultado: null,
    error_elo: false,
    simuladorDisponivel: false
};

export default (state= INITIAL_STATE, action) =>{
    switch(action.type){

        /* Atualização do formulário */
        case 'SIMULACAO_ATUALIZAR_DATA_NASCIMENTO':
            return {...state, data: {...state.data, consultaFiliado: {...state.data.consultaFiliado, filiadoTO: {...state.data.consultaFiliado.filiadoTO, dataNascimento: action.payload}}}}

        /* Atualização da lista de vínculos */
        case 'SIMULACAO_ERRO_ADICIONAR_VINCULO':
            return {...state,esperandoRespostaSolicitacao:false, mensagem: MSG_ERRO_FORMULÁRIO_INCOMPLETO };

        /* Atualização do formulário Edição */
        case 'SIMULACAO_ATUALIZAR_EDIT_DATA_INICIO':
            return {...state, vinculoEdicao: { ...state.vinculoEdicao,dataInicio : action.payload }  }
        case 'SIMULACAO_ATUALIZAR_EDIT_DATA_FIM':
            return {...state, vinculoEdicao: { ...state.vinculoEdicao,dataFim : action.payload }  }
        case 'SIMULACAO_ATUALIZAR_EDIT_KEY':
            return {...state, vinculoEdicao: { ...state.vinculoEdicao,editKey : action.payload }  }

       /* Solicitando dados */
        case 'SIMULACAO_DADOS_SOLICITADOS':
            return {...state, loadingExtrato: true, erroDeSolicitacao:"", erroElegivel: false, semExtrato: false, error_elo: false}
        case 'SIMULACAO_ERRO_RECEBIDO':
            return {...state, erroDeSolicitacao: action.payload, loadingExtrato: false, mensagem: action.payload};
        case 'SIMULACAO_DADOS_RECEBIDOS':
            if(action.payload.consultaFiliado && 
                action.payload.consultaFiliado.filiadoTO &&
                action.payload.consultaFiliado.filiadoTO.dataNascimento) {
                    action.payload.consultaFiliado.filiadoTO.dataNascimento = action.payload.consultaFiliado.filiadoTO.dataNascimento.split('T')[0];
            }
            if(!action.payload.extrato || !action.payload.extrato.listaVinculosTO) {
                action.payload.extrato = {listaVinculosTO: []};
            }
            return {...state, loadingExtrato: false, mensagem: '', data: action.payload}

        /* Editando vinculos */
         case 'SIMULACAO_EDITAR_VINCULO':
            return {...state, mensagem:'', vinculoEdicao: {nomeVinculo: "", dataInicio: "", dataFim: "", editKey: "" },
                data: {...state.data, extrato: {...state.data.extrato, listaVinculosTO: action.payload.vinculos} }
            };
        case 'SIMULACAO_REMOVER_VINCULO':
            return {...state, data: {...state.data, extrato: {...state.data.extrato, listaVinculosTO: action.payload} } };
        case 'SIMULACAO_ADICIONAR_VINCULO':
            return {...state, mensagem:'', vinculoCriacao:{nomeVinculo: "",dataInicio: "",  dataFim: ""},
                data: {...state.data, extrato: 
                        {...state.data.extrato, listaVinculosTO: [...state.data.extrato.listaVinculosTO, action.payload] } 
                }
            };

        case 'SIMULACAO_EDITAR_SUBSTITUICAO_VINCULOS':
            return {...state, data: {...state.data, extrato: {...state.data.extrato, listaVinculosTO: action.payload} } }

        /* Solicitação de simulações */
        case 'SIMULACAO_SOLICITADA':
            return {...state, mensagem:'',loading: true, erroElegivel:false, semExtrato: false };

        case 'SIMULACAO_RECEBIDA':
            /*enquanto o campo tempoACumprirAposentadoria não vem para o tipo EC_103_30_35_ANOS_CONTRIBUICAO_PONTUACAO_MINIMA
            pegamos emprestado do EC_103_FILIADOS_COM_CONTRIBUICAO*/
            if(action.payload.simulacao && action.payload.simulacao.listaDireitoRenda && action.payload.simulacao.listaDireitoRenda.length == 7) {
                if(action.payload.simulacao.listaDireitoRenda[3].hasOwnProperty('extratoLaboral') && action.payload.simulacao.listaDireitoRenda[4].hasOwnProperty('extratoLaboral') && !action.payload.simulacao.listaDireitoRenda[3].extratoLaboral.hasOwnProperty('tempoACumprirAposentadoria')) {
                    action.payload.simulacao.listaDireitoRenda[3].extratoLaboral.tempoACumprirAposentadoria = action.payload.simulacao.listaDireitoRenda[4].extratoLaboral.tempoACumprirAposentadoria;
                }
            }
            return {...state, mensagem:'', loading:false, resultado: action.payload.simulacao };

        case 'SIMULACAO_ERRO_SIMULAR':
            return {...state, mensagem: action.payload, loading:false, resultado:'erro', erroDeSolicitacao: action.payload };

        case 'SIMULACAO_ERRO_SOLICITAR_SIMULACAO':
            return {...state, loading: false, mensagem: MSG_SIMULACAO_ERRO_SOLICITAR};

        case 'SIMULACAO_LIMPAR_RESULTADOS':
            return {...state, resultado:null};

        case 'SIMULACAO_ATUALIZAR_GENERO':
            return {...state, 
                data: {...state.data, consultaFiliado: {...state.data.consultaFiliado, filiadoTO: {...state.data.consultaFiliado.filiadoTO, sexo: action.payload} }} } 

        case 'SIMULACAO_IMPRESSAO_SOLICITADA':
            return {...state, loadingImpressao: true};

        case 'SIMULACAO_IMPRESSAO_RECEBIDA':
        case 'SIMULACAO_IMPRESSAO_ERRO':
            return {...state, loadingImpressao: false};

        case 'SIMULACAO_ATUALIZAR_VINCULO_EDITAVEL':
            return {...state, edicao: {
                cardId: action.payload.cardId,
                dataInicio: action.payload.dataInicio,
                dataFim: action.payload.dataFim,
                remuneracoes: action.payload.remuneracoes,
                nomeVinculo: action.payload.nomeVinculo,
                tipoVinculo: action.payload.tipoVinculo
            }};

        case 'SIMULACAO_ATUALIZAR_REMUNERACAO_EDICAO':
            if(action.payload.tipoVinculo === 'relacao' || !action.payload.tipoVinculo) { //relacao ou novo
              state.edicao.remuneracoes[action.payload.index].valor = action.payload.value;
            } else { //recolhimento
              state.edicao.remuneracoes[action.payload.index].salarioContribuicao = action.payload.value;
            }
            return {...state, edicao: {...state.edicao, remuneracoes:  state.edicao.remuneracoes }};

        case 'SIMULACAO_NAO_ELEGIVEL':
            return {...state, loading: false, erroElegivel: true};

        case 'SIMULACAO_SEM_EXTRATO':
            return {...state, loadingExtrato: false, semExtrato: true}

        case 'SIMULACAO_ERRO_ELO':
           return { ...state, loadingExtrato: false, loading: false, error_elo: true };

        case 'SIMULACAO_DISPONIVEL':
            return { ...state, simuladorDisponivel: action.payload };

        default:
            return state;
    }
}
